import React from "react";
import { Icon } from "@chakra-ui/react";
import { VerifiedIconProps } from "./VerifiedIcon.types";
import BadgeIcon from "../badge-icons/BadgeIcon";
import { VeriTooltip } from "../../popover";

export const VerifiedIcon: React.FC<VerifiedIconProps> = ({
  message,
  iconProps,
  notVerified,
  withPopover = true,
  messages = {
    verified: "Verivest verified.",
    notVerified: "Not Verivest verified.",
  },
  ...rest
}) => {
  if (!message) {
    message = notVerified ? messages.notVerified : messages.verified;
  }
  const [triggerRef, setTriggerRef] = React.useState<HTMLDivElement | null>(
    null,
  );

  return (
    <>
      <Icon
        cursor="pointer"
        color={notVerified ? "icons.grey" : "brand.main"}
        verticalAlign="top"
        boxSize="20px"
        as={BadgeIcon}
        ref={setTriggerRef as never}
        {...iconProps}
        {...rest}
      />
      {withPopover && triggerRef && (
        <VeriTooltip
          trigger={triggerRef}
          label={message || "This investment manager is Verivest verified."}
        />
      )}
    </>
  );
};
